import { useRef } from "react";
import { createUseStyles } from "react-jss";
import clsx from "clsx";

const useStyles = createUseStyles(theme => ({
  "@keyframes fadein": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  container: {
    display: "flex",
    visibility: "hidden",
    opacity: 0,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgb(0, 0, 0, 0.3)",
    zIndex: 20,
    alignItems: "center",
    justifyContent: "center",
    lineHeight: "normal",
  },
  active: {
    visibility: "visible",
    animation: "$fadein ease 0.2s forwards",
  },
  inner: {
    backgroundColor: "#000",
    padding: theme.spacing4,
    border: `#7a7979 solid 1px`,
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: 299,
    borderRadius: 5,
    "& hr": {
      width: "100%",
    },
    "& h3": {
      whiteSpace: "nowrap",
      fontWeight: "bold",
      textAlign: "center",
      color: "#ff0050",
      marginTop: 0,
    },
  },
}));

const Lightbox = ({ children, show, onClose, className }) => {
  const classes = useStyles();
  const selfRef = useRef();

  return (
    <div
      ref={selfRef}
      onClick={e => {
        if (e.target === selfRef.current) {
          onClose(e);
        }
      }}
      className={clsx(classes.container, { [classes.active]: show })}
    >
      <div
        className={clsx(classes.inner, className, {
          [classes.active]: show,
        })}
      >
        {children}
      </div>
    </div>
  );
};

export default Lightbox;
